module.exports = __webpack_public_path__ + "static/media/csm-checkmark.939c87c7.svg";